import { Result } from "@praha/byethrow"
import { createServerFn } from "@tanstack/react-start"
import { getUserAgreement as getUserAgreementService } from "@apps/gwservice/user-agreement"

export const getUserAgreement = createServerFn({
  method: "GET",
})
  .handler(() => Result.try({
    try: () => getUserAgreementService(),
    catch: () => "unexpected server error",
  }))
